import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogConstruction } from "../../../../store/catalog/actions";
export var useGetCatalogConstruction = function (trigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseCatalogConstruction: (_a = state.Catalog.responseCatalogConstruction) === null || _a === void 0 ? void 0 : _a.data,
            loadingCatalogConstruction: state.Catalog.loadingCatalogConstruction,
            errorCatalogConstruction: state.Catalog.errorCatalogConstruction,
        });
    }), responseCatalogConstruction = _a.responseCatalogConstruction, loadingCatalogConstruction = _a.loadingCatalogConstruction, errorCatalogConstruction = _a.errorCatalogConstruction;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogConstruction({
                enable: true,
                page: 1,
                limit: 1000,
                type: "CATALOG_TYPE_CONSTRUCTION",
            }));
        }
    }, [trigger]);
    return {
        responseCatalogConstruction: responseCatalogConstruction,
        loadingCatalogConstruction: loadingCatalogConstruction,
        errorCatalogConstruction: errorCatalogConstruction,
    };
};
